<template class="autocomplete">
  <div>
    <md-input-container>
        <label>{{label}}</label>
        <md-input @input="updateValue($event)" :value="value" ref="input" v-focus.lazy></md-input>
        <md-icon>search</md-icon>
    </md-input-container>
    <md-menu
        md-size="5" 
        md-direction="top right"
        ref="menu"
        class="md-autocomplete-menu">
        <span md-menu-trigger></span>
        <md-menu-content class="content-autocomplete">
            <md-menu-item @click.native="select(item)" v-for="item in arrayFilter" :key="item['.key']">
                <md-avatar>
                    <img :src="item.photoURL">
                </md-avatar>
                <span>{{item.displayName}}</span>
            </md-menu-item>
        </md-menu-content>
    </md-menu>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'autocomplete',
  props: ['value', 'label', 'array', 'debounce'],
  data () {
    return {
      selected: null,
      timeout: 0,
      arrayFilter: []
    }
  },
  methods: {
    filter (param) {
      if (this.timeout) {
        window.clearTimeout(this.timeout)
      }
      this.timeout = window.setTimeout(() => {
        if (this.array.length !== 0) {
          if (param) {
            this.arrayFilter = _.filter(this.array, function (o) { return o.displayName.toLowerCase().includes(param.toLowerCase()) })
            if (this.arrayFilter.length !== 0) {
              this.$refs.menu.toggle()
            }
          } else {
            this.arrayFilter = []
          }
          return
        }
      }, this.debounce)
    },
    updateValue (value) {
      this.filter(value)
      this.$emit('input', value)
    },
    select (item) {
      this.$emit('input', item.displayName)
      this.arrayFilter = []
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .md-error {
    color: red;
  }

  .content-autocomplete {
    overflow-y: auto;
  }

</style>



// WEBPACK FOOTER //
// Autocomplete.vue?810d2358